import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { NexyomLogo } from './NexyomLogo';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-black text-white overflow-hidden" data-id="element-53">
      {/* Enhanced grid background with depth */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:80px_80px]" data-id="element-54" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/50" data-id="element-55" />

      {/* Accent geometric element */}
      <div className="absolute top-20 right-20 w-32 h-32 border-2 border-blue-500/20" data-id="element-56" />
      <div className="absolute bottom-32 left-20 w-24 h-24 border-2 border-blue-500/10" data-id="element-57" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-12" data-id="element-59">
          <NexyomLogo variant="full" colorScheme="dark" size="xl" data-id="element-60" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.15,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-61">
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-8 leading-tight" data-id="element-62">
            Performance.
            <br data-id="element-63" />
            Croissance.
            <br data-id="element-64" />
            <span className="text-blue-500" data-id="element-65">Ingénierie.</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-xl md:text-2xl text-gray-400 mb-14 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-66">
          Marketing, business et technologie pour faire croître votre
          entreprise.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-67">
          <a href="#contact" className="group inline-flex items-center gap-3 bg-blue-500 text-white px-10 py-5 text-lg font-semibold transition-all duration-300 hover:bg-blue-600 hover:gap-4 relative overflow-hidden" data-id="element-68">
            <span className="relative z-10" data-id="element-69">Contactez Nexyom</span>
            <ArrowRightIcon className="w-5 h-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-70" />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-71" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.2,
        delay: 0.8
      }} className="absolute bottom-16 left-1/2 -translate-x-1/2" data-id="element-72">
          <div className="w-6 h-11 border-2 border-gray-700 flex items-start justify-center p-2" data-id="element-73">
            <motion.div animate={{
            y: [0, 14, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-1 h-2 bg-gray-600" data-id="element-74" />
          </div>
        </motion.div>
      </div>
    </section>;
}